import { BILLING_OPERATIONAL_API } from './apiPaths.js';

/**
 * Dual-shell route registry — same workflow, different paths per UI shell.
 * @typedef {'HMS_SHELL' | 'HEALTHCARE_UI'} UiShell
 */

export const UI_SHELL = {
  HMS_SHELL: 'HMS_SHELL',
  HEALTHCARE_UI: 'HEALTHCARE_UI',
};

export const OPERATIONAL_WORKFLOWS = {
  OP_BILLING_COUNTER: {
    id: 'OP_BILLING_COUNTER',
    apiBase: BILLING_OPERATIONAL_API.OP_COUNTER,
    capability: 'OP_BILLING_COUNTER',
    routes: {
      HMS_SHELL: '/billing/counter',
      HEALTHCARE_UI: '/billing/workspace',
    },
    productionSafe: true,
  },
  PATIENT_JOURNEY: {
    id: 'PATIENT_JOURNEY',
    apiBase: BILLING_OPERATIONAL_API.PATIENT_JOURNEY,
    capability: 'PATIENT_JOURNEY',
    routes: {
      HMS_SHELL: '/workspace/patient',
      HEALTHCARE_UI: '/billing/patient-journey',
    },
  },
  IP_DISCHARGE: {
    id: 'IP_DISCHARGE',
    apiBase: BILLING_OPERATIONAL_API.IP_DISCHARGE,
    capability: 'IP_DISCHARGE',
    routes: {
      HMS_SHELL: '/billing/ip-discharge',
      HEALTHCARE_UI: '/billing/ip-discharge',
    },
  },
  SHIFT_CONTINUITY: {
    id: 'SHIFT_CONTINUITY',
    apiBase: BILLING_OPERATIONAL_API.SHIFT_CONTINUITY,
    capability: 'SHIFT_CONTINUITY',
    routes: {
      HMS_SHELL: '/billing/shift-continuity',
      HEALTHCARE_UI: '/billing/shift-continuity',
    },
  },
  OPERATIONAL_ALERTS: {
    id: 'OPERATIONAL_ALERTS',
    apiBase: BILLING_OPERATIONAL_API.OPERATIONAL_ALERTS,
    capability: 'OPERATIONAL_ALERTS',
    routes: {
      HMS_SHELL: '/billing/operational-alerts',
      HEALTHCARE_UI: '/billing/operational-alerts',
    },
  },
  OPERATIONS_DESK: {
    id: 'OPERATIONS_DESK',
    apiBase: BILLING_OPERATIONAL_API.OPERATIONS_DESK,
    capability: 'OP_BILLING_COUNTER',
    routes: {
      HMS_SHELL: '/billing/counter',
      HEALTHCARE_UI: '/billing/operations-desk',
    },
  },
  PATIENT_TOKEN_QUEUE: {
    id: 'PATIENT_TOKEN_QUEUE',
    apiBase: null,
    capability: 'FRONT_OFFICE',
    routes: {
      HMS_SHELL: '/workspaces/reception',
      HEALTHCARE_UI: '/healthcare-portal/patient-token',
    },
    productionSafe: true,
    note: 'Legacy OP token queue — unchanged in healthcare-ui production',
  },
  REFUND_REVIEW: {
    id: 'REFUND_REVIEW',
    apiBase: BILLING_OPERATIONAL_API.OP_COUNTER,
    capability: 'REFUND_REVIEW',
    routes: {
      HMS_SHELL: '/billing/refund-review-queue',
      HEALTHCARE_UI: '/billing/refund-review-queue',
    },
  },
};

export function workflowRoute(workflowId, shell = UI_SHELL.HMS_SHELL) {
  const wf = OPERATIONAL_WORKFLOWS[workflowId];
  return wf?.routes?.[shell] ?? '/';
}

export function workflowApiBase(workflowId) {
  return OPERATIONAL_WORKFLOWS[workflowId]?.apiBase ?? null;
}
